import {
  EServiceType,
  ICheckPublishTermSchema,
} from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { IServicePeriod, IServicePackage } from '../../../../types/reducers/publishTerms';
import { mapInternalServiceTypes } from '../../../../utils/publishTerms';

export function mapPublishTerm(publishOption: IServicePeriod | IServicePackage): ICheckPublishTermSchema {
  const { type, days, tariffIdentificator, token } = publishOption;
  const { serviceTypes } = tariffIdentificator;

  const services = mapInternalServiceTypes<EServiceType>(serviceTypes);

  return {
    type,
    days,
    tariffIdentificator,
    services,
    token,
  };
}
